<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><a id="page_ix"></a><em>To</em></p>
<p class="center" dir="rtl" xml:lang="he"><span class="shlomo">צה״ל</span></p>
<p class="center"><em>The Israel Defense Force</em></p>
<p class="center"><em>Above all to those who fell</em></p>
<p class="center"><em>And to those who survived, to those who now stand guard, and to those who will stand guard until by God’s grace Israel dwells in peace with all her neighbors</em></p>
<p class="center"><em>This tale of Hope is dedicated</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795344114_epub_ded_r1.vue?7e335e97